var App = App || {};

App.OUPShibboleth = (function ($) {
    return {
        init: init
    };

    function init() {
        $(document).on('click', '.js-shibboleth-action', handleClick);
    };

    function handleClick(e) {
        e.preventDefault();
        const $target = $(e.currentTarget);
        const actionType = $target.data('action-type');
        const entityId = $target.data('entity-id');
        const zEncodedRedirectUrl = SCM.LoginBox.getZEncodedRedirectUrl();

        try {
            getShibbolethUrl(actionType, entityId)
                .then((shibbolethUrl) => {
                    SCM.LoginBox.updateHrefPlaceholder($target, zEncodedRedirectUrl, shibbolethUrl);
                    window.location.href = $target.attr('href');
                })
                .catch((reason) => console.error(reason));
        } catch (error) {
            console.error(error);
        }
    };

    function getShibbolethUrl(actionType, entityId) {
        return SCM.Ajax.post('/Accounts/GetShibbolethUrl', { actionType: actionType, entityId: entityId })
            .expectJson()
            .then((response) => {
                if (response.success) {
                    return response.url;
                } else {
                    throw new Error('Error getting Shibboleth URL: ' + response.message);
                }
            })
    }
})(jQuery);